<template>
  <div>
    <div v-for="file in attachmentsItem" :key="file.formAttachmentId" class="document-row">
      <v-btn
        icon
        small
        :loading="loading.includes(file.formAttachmentId)"
        @click="onDownload(file.formAttachmentId)"
        :title="`Download ${file.fileName}`"
        color="brandPrimary"
        class="download-attachment-btn"
      >
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <Typography
        variant="body-2"
        class="file-name clickable-download"
        @click="onDownload(file.formAttachmentId)"
        >{{ file.fileName }}</Typography
      >
      <Typography
        v-if="file.createDate || file.createdAt"
        variant="caption-1"
        class="document-date"
        >{{ formatDate(file.createDate || file.createdAt) }}</Typography
      >
      <Typography
        v-if="file.createdByName && hasAdditionalClaimants"
        variant="caption-1"
        class="document-date"
        >by {{ file.createdByName }}</Typography
      >
    </div>
  </div>
</template>

<script>
// Mixins
import fileDownloadMixin from "@/mixins/forms/formFileDownloadMixin";

// Components
import Typography from "@/components/generic/Typography.vue";

// Packages
import moment from "moment";

export default {
  name: "FormFileList",
  mixins: [fileDownloadMixin],
  components: {
    Typography,
  },
  props: {
    // Array of FormAttachments
    attachmentsItem: {
      type: Array,
      default: () => [],
    },
    hasAdditionalClaimants: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Array of formAttachmentIds that are currently awaiting a signed url
      loading: [],
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).local().format("M/DD/YYYY");
    },
    async onDownload(formAttachmentId) {
      if (this.loading.includes(formAttachmentId)) return;

      this.loading.push(formAttachmentId);
      try {
        await this.downloadFileById(formAttachmentId);
      } finally {
        this.loading = this.loading.filter((id) => id !== formAttachmentId);
      }
    },
  },
};
</script>

<style scoped>
.document-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding-bottom: 8px;
}
.clickable-download {
  cursor: pointer;
  text-decoration: underline;
  text-align: left;
}
/* Lose the underline on hover */
.clickable-download:hover {
  text-decoration: none;
}
.v-list-item__action {
  margin: 0 0.5em 0 0 !important;
}
.document-date {
  color: var(--v-grey-darken2);
}
</style>
